import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  videoList: [],
  videoFormList: [],
  videoDetail: [],
  videoAnalyticsPublic: [],
  videoAnalyticsProtected: [],
  success: false,
  loading: false,
  loadingPublic: false,
  loadingProtected: false,
  error: undefined,
  actionType: null,
};

const videoSlice = createSlice({
  name: "video",
  initialState,
  reducers: {
    clearError(state) {
      state.loading = false;
      state.loadingPublic = false;
      state.loadingProtected = false;
      state.success = false;
      state.error = undefined;
    },
    actionStart(state) {
      state.loading = true;
      state.error = undefined;
      state.actionType = null;
    },
    actionStartPublic(state) {
      state.loadingPublic = true;
    },
    actionStartProtected(state) {
      state.loadingProtected = true;
    },
    actionSuccess(state, action) {
      state.success = true;
      state.loading = false;
      state.actionType = action.payload || null;
    },
    fetchVideoList(state, action) {
      state.videoList = action.payload;
      state.loading = false;
    },
    fetchVideoFormList(state, action) {
      state.videoFormList = action.payload;
      state.loading = false;
    },
    fetchVideoDetail(state, action) {
      state.videoDetail = action.payload;
      state.loading = false;
    },
    fetchVideoAnalyticsPublic(state, action) {
      state.videoAnalyticsPublic = action.payload;
      state.loadingPublic = false;
    },
    fetchVideoAnalyticsProtected(state, action) {
      state.videoAnalyticsProtected = action.payload;
      state.loadingProtected = false;
    },
  },
});

export const videoActions = videoSlice.actions;

export default videoSlice.reducer;
